import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./ResetPasswordScreen.css";
import { get, post } from "../../../api/api";

const ResetPasswordScreen = () => {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(true);
  const [tokenValid, setTokenValid] = useState(false);
  const [resetSuccess, setResetSuccess] = useState(false);

  const location = useLocation();
  const token = new URLSearchParams(location.search).get("token");

  useEffect(() => {
    const verifyToken = async () => {
      if (!token) {
        setTokenValid(false);
        setLoading(false);
        return;
      }

      try {
        const encoded = encodeURIComponent(token);
        const data = await get(`/auth/verify-reset-token?token=${encoded}`);
        setTokenValid(data.valid === true);
      } catch {
        setTokenValid(false);
      } finally {
        setLoading(false);
      }
    };

    verifyToken();
  }, [token]);

  const handleResetPassword = async () => {
    if (password.trim() === "") return alert("Please enter your new password.");
    if (password !== confirm) return alert("Passwords do not match.");

    try {
      await post("/auth/reset-password", { token, password });
      setResetSuccess(true);
    } catch (error) {
      alert("Reset failed: " + (error?.message || "Try again."));
    }
  };

  if (loading) {
    return (
      <div className="reset-password-container">
        <p>Verifying reset link...</p>
      </div>
    );
  }

  if (resetSuccess) {
    return (
      <div className="reset-success-container">
        <h2 className="reset-success-title">Password Reset Successful</h2>
        <p className="reset-success-message">
          You can now log in with your new password.
        </p>
      </div>
    );
  }

  if (!tokenValid) {
    return (
      <div className="invalid-token-container">
        <h2>Reset Link Expired or Invalid</h2>
        <p>
          This password reset link is no longer valid. It might be expired or
          already used.
        </p>
      </div>
    );
  }

  return (
    <div className="reset-password-container">
      <h2>Reset Your Password</h2>
      <input
        type="password"
        placeholder="New password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="reset-input"
      />
      <input
        type="password"
        placeholder="Confirm password"
        value={confirm}
        onChange={(e) => setConfirm(e.target.value)}
        className="reset-input"
      />
      <button onClick={handleResetPassword} className="reset-button">
        Reset Password
      </button>
    </div>
  );
};

export default ResetPasswordScreen;
